import { useState } from "react";
import { useAxios } from "@/app/providers/AxiosProvider";

export default function usePortfolioUpload() {
  const axios = useAxios();
  const [isUploadingFile, setIsUploadingFile] = useState(false);
  const [isUploadingImage, setIsUploadingImage] = useState(false);

  const upload = async (candidateUuid, file) => {
    setIsUploadingFile(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axios.post(
        `/candidate/${candidateUuid}/portfolio/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } finally {
      setIsUploadingFile(false);
    }
  };

  const uploadImage = async (candidateUuid, file) => {
    setIsUploadingImage(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axios.post(
        `/candidate/${candidateUuid}/portfolio/upload-image`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } finally {
      setIsUploadingImage(false);
    }
  };

  const isUploading = isUploadingFile || isUploadingImage;

  return { upload, uploadImage, isUploading, isUploadingFile, isUploadingImage };
}
